import {
    ExpectedStorefrontError,
    reportCaughtStorefrontError,
    storefrontResponseError,
} from '../client-runtime/client-runtime-report.js';

export async function toggleWishlist(button) {
    const productId = Number(button.dataset.productId || button.dataset.productWishlist);
    if (!Number.isSafeInteger(productId) || productId <= 0 || button.disabled) return null;

    const saved = button.classList.contains('is-added');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
        const response = await fetch(
            saved
                ? '/index.php?route=account/wishlist/remove'
                : '/index.php?route=account/wishlist/add',
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: new URLSearchParams({ product_id: String(productId) }),
            },
        );
        if (!response.ok)
            throw storefrontResponseError(
                response,
                `Wishlist request failed with HTTP ${response.status}`,
                [400, 401, 403, 422, 429],
            );
        const result = await response.json();
        if (result.redirect) {
            window.location.assign(result.redirect);
            return null;
        }
        if (!result.success)
            throw result.error
                ? new ExpectedStorefrontError(result.error)
                : new Error('Der Merkzettel ist gerade nicht verfügbar.');

        const nextSaved = !saved;
        button.classList.toggle('is-added', nextSaved);
        document.dispatchEvent(
            new CustomEvent('zirbelino:wishlist:change', {
                detail: { productId, saved: nextSaved },
            }),
        );
        return { productId, saved: nextSaved, result };
    } catch (error) {
        reportCaughtStorefrontError(error, 'wishlist_update', {
            product_id: productId,
            operation: saved ? 'remove' : 'add',
        });
        throw error;
    } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
    }
}
